import { z } from 'zod';
import { csvList } from './common.js';
import { CSAT_SCORES } from '../csat.js';
import { VISIT_STATUSES } from '../visit-state.js';
import { paginationSchema, text } from './common.js';
export const visitSchema = z.object({
    id: z.number().int(),
    status: z.enum(VISIT_STATUSES),
    technicianId: z.number().int(),
    technician: z.string(),
    technicianColor: z.number().int(),
    facilityId: z.number().int(),
    facility: z.string(),
    facilityBu: z.string(),
    clusterId: z.number().int().nullable(),
    cluster: z.string().nullable(),
    scheduledAt: z.string(),
    durationMinutes: z.number().int(),
    scopeOfWork: z.string(),
    additionalTasks: z.string().nullable(),
    checkInAt: z.string().nullable(),
    checkInIp: z.string().nullable(),
    checkInLocation: z.string().nullable(),
    checkOutAt: z.string().nullable(),
    checkOutIp: z.string().nullable(),
    checkOutLocation: z.string().nullable(),
    engineerNotes: z.string().nullable(),
    adminNotes: z.string().nullable(),
    csat: z.enum(CSAT_SCORES).nullable(),
    signedAt: z.string().nullable(),
    signedBy: z.string().nullable(),
    approvedAt: z.string().nullable(),
    cancelledAt: z.string().nullable(),
    cancellationReason: z.string().nullable(),
    rescheduledFromId: z.number().int().nullable(),
    rescheduledToId: z.number().int().nullable(),
    closedAt: z.string().nullable(),
    calendarSyncStatus: z.enum(['none', 'pending', 'synced', 'failed']),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const visitEventSchema = z.object({
    id: z.number().int(),
    action: z.string(),
    actorId: z.number().int().nullable(),
    actor: z.string().nullable(),
    fromStatus: z.enum(VISIT_STATUSES).nullable(),
    toStatus: z.enum(VISIT_STATUSES).nullable(),
    changes: z.unknown().nullable(),
    ip: z.string().nullable(),
    createdAt: z.string(),
});
export const visitDetailSchema = visitSchema.extend({ events: z.array(visitEventSchema) });
export const VISIT_SORTS = ['scheduled_asc', 'scheduled_desc', 'status', 'updated_desc'];
export const visitFiltersSchema = paginationSchema.extend({
    status: csvList(z.enum(VISIT_STATUSES)),
    technicianId: z.coerce.number().int().positive().optional(),
    facilityId: z.coerce.number().int().positive().optional(),
    clusterId: z.coerce.number().int().positive().optional(),
    /** ISO dates or date-times bounding scheduled_at (inclusive from, exclusive to). */
    from: z.string().datetime({ offset: true }).or(z.iso.date()).optional(),
    to: z.string().datetime({ offset: true }).or(z.iso.date()).optional(),
    wip: z
        .enum(['true', 'false'])
        .transform((v) => v === 'true')
        .optional(),
    q: text(0, 120).optional(),
    sort: z.enum(VISIT_SORTS).default('scheduled_desc'),
});
//# sourceMappingURL=visits.js.map